/**
 * Symbol behind which the fixed arguments and the original function are stored.
 * @private
 */
module.exports = Symbol('_PARTIAL_KEY')
